const colors = {
  /* Palette */
  darkGreen: 'rgb(0, 125, 125)',
  lightGreen: 'rgb(0, 218, 188)',
  darkPurple: 'rgb(100, 25, 100)',
  lightPurple: 'rgb(233, 221, 232)',
  orange: 'rgb(255, 179, 80)',

  /* Neutrals */
  smoke: 'rgb(245, 245, 245)',
  lightGrey: 'rgb(239, 239, 239)',
  grey: 'rgb(120, 120, 120)',
  black: 'rgb(0, 0, 0)',
  white: 'rgb(255, 255, 255)',
};

export default colors;
